/* Nr. 16 (M22): Produktseite am Handy.
   Haken: layout/theme.liquid (render 'lc-produkt-mobil'), geladen mit defer.
   Aufgaben:
     1. Feste Kaufleiste ein- und ausblenden (nur Handy, unter 768 px).
     2. Hilfe-Knopf (Freshdesk) ausweichen lassen.
     3. "Mehr lesen" im Kurztext springt zur vollstaendigen Beschreibung.
     4. Messereignisse lc_pdp_* (Konvention 4.5, Helfer window.lcMessen).
   Rueckweg: Haken in layout/theme.liquid entfernen, dann Datei loeschen.
   Das Skript wirft nie: jede Stelle ist einzeln abgesichert, damit ein Fehler
   hier den Kaufweg nie stoppt. */
(function () {
  'use strict';

  var NR = '16';
  var doc = document;
  var win = window;
  var root = doc.documentElement;
  var leiste = doc.getElementById('lc-kaufleiste');
  var kurztext = doc.querySelector('.lc-kurztext[data-lc-nr="16"]');
  var handle = (leiste && leiste.getAttribute('data-lc-handle')) ||
    (kurztext && kurztext.getAttribute('data-lc-handle')) || '';

  var mql = win.matchMedia ? win.matchMedia('(max-width: 767.98px)') : null;
  function amHandy() {
    return !!(mql && mql.matches);
  }

  /* --- Messen (gleiche Logik wie nbMessen im Konfigurator) -------------- */
  win.lcMessen = win.lcMessen || function (name, daten) {
    try {
      if (typeof win.hj === 'function') win.hj('event', name);
    } catch (e) { /* Hotjar darf das Messen nie blockieren */ }
    try {
      if (!Array.isArray(win.dataLayer)) win.dataLayer = [];
      win.dataLayer.push(Object.assign({ event: name, lc_nr: NR }, daten || {}));
    } catch (e) { /* dataLayer darf das Messen nie blockieren */ }
    try {
      if (win.Shopify && win.Shopify.analytics && typeof win.Shopify.analytics.publish === 'function') {
        win.Shopify.analytics.publish(name, Object.assign({ lc_nr: NR }, daten || {}));
      }
    } catch (e) { /* Shopify-Analytics darf das Messen nie blockieren */ }
  };
  function messen(name, daten) {
    try {
      win.lcMessen(name, Object.assign({ lc_nr: NR, handle: handle }, daten || {}));
    } catch (e) { /* nie werfen */ }
  }

  /* --- Hauptknopf ------------------------------------------------------- */
  /* Die Schnellansicht (quick-view-modal, z. B. aus "Pairs well with") nutzt
     dieselbe Formularklasse main-product-form; ihr Knopf ist nie der Hauptknopf. */
  function hauptKnopf() {
    var liste = doc.querySelectorAll('.main-product-form .product-form__submit');
    for (var i = 0; i < liste.length; i++) {
      if (!liste[i].closest('quick-view-modal')) return liste[i];
    }
    return null;
  }

  /* --- Leiste ein- und ausblenden --------------------------------------- */
  var leisteAn = false;
  var gezeigtGemeldet = false;

  function leisteHoehe() {
    return leiste ? leiste.offsetHeight : 0;
  }

  function setzeHoehe(an) {
    var h = an ? leisteHoehe() : 0;
    root.style.setProperty('--lc-leiste-h', h + 'px');
    /* back-to-top im Theme rechnet mit dieser Variable */
    root.style.setProperty('--sticky-atc-bar-height', h + 'px');
  }

  function zeige(an) {
    if (!leiste) return;
    an = !!an && amHandy();
    if (an === leisteAn) {
      if (an) setzeHoehe(true);
      return;
    }
    leisteAn = an;
    leiste.classList.toggle('lc-kaufleiste--an', an);
    if (an) {
      leiste.removeAttribute('inert');
    } else {
      leiste.setAttribute('inert', '');
    }
    root.classList.toggle('lc-leiste-an', an);
    if (doc.body) doc.body.classList.toggle('lc-kaufleiste-an', an);
    setzeHoehe(an);
    if (an && !gezeigtGemeldet) {
      gezeigtGemeldet = true;
      messen('lc_pdp_leiste_gezeigt');
    }
    hilfeCheck();
  }

  var beobachter = null;
  var beobachterKnopf = null;
  function leisteStarten() {
    if (!leiste || !('IntersectionObserver' in win)) return;
    var knopf = hauptKnopf();
    /* Ohne Hauptknopf keine Leiste (die Theme-Leiste stuende dann dauerhaft) */
    if (!knopf) return;
    beobachterKnopf = knopf;
    beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        zeige(e.intersectionRatio !== 1);
      });
      hilfePlanen();
    }, { threshold: 1, rootMargin: '-80px 0px 0px 0px' });
    beobachter.observe(knopf);
    if ('ResizeObserver' in win) {
      try {
        new ResizeObserver(function () {
          if (leisteAn) setzeHoehe(true);
        }).observe(leiste);
      } catch (e) { /* ohne ResizeObserver bleibt die letzte Hoehe */ }
    }
  }

  /* Beim Wechsel in die Handy-Breite (Drehen, Fenster schmaler ziehen) meldet
     der Beobachter von sich aus nichts, solange der Knopf nicht die Schwelle
     kreuzt. Neu anmelden liefert einen frischen Start-Rueckruf. */
  function leisteNeuPruefen() {
    if (!beobachter || !beobachterKnopf) return;
    beobachter.unobserve(beobachterKnopf);
    beobachter.observe(beobachterKnopf);
  }

  /* Verschiebt sich der Hauptknopf ohne Scrollen (Judge.me-Badge, Schriften,
     Bilder laden nach), stimmt der Zustand des Hilfe-Knopfs nicht mehr. Der
     Container der Produktbloecke waechst dabei mit; darauf hoeren wir. */
  function hilfeBeobachten() {
    var knopf = hauptKnopf();
    if (!knopf) return;
    if ('ResizeObserver' in win) {
      try {
        var behaelter = knopf.closest('.product__blocks') || doc.body;
        if (behaelter) new ResizeObserver(hilfePlanen).observe(behaelter);
      } catch (e) { /* dann bleiben scroll, resize, load und fonts */ }
    }
    try {
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(hilfePlanen, function () {});
    } catch (e) { /* nie werfen */ }
    win.addEventListener('load', hilfePlanen);
  }

  /* --- Hilfe-Knopf (Freshdesk) ------------------------------------------ */
  /* Liegt die Leiste im Bild, steht der Hilfe-Knopf per CSS darueber. Steht der
     Hauptknopf im Bild und im unteren Bereich (Unterkante unter innerHeight
     minus 76 px), laege der Hilfe-Knopf auf ihm: dann blenden wir ihn aus,
     bis der Knopf weiter oben steht oder die Leiste kommt. */
  var hilfeWeg = false;
  function hilfeCheck() {
    var weg = false;
    if (amHandy() && !leisteAn) {
      var knopf = hauptKnopf();
      if (knopf) {
        var r = knopf.getBoundingClientRect();
        var hoehe = win.innerHeight || root.clientHeight;
        if (r.height > 0 && r.top < hoehe && r.bottom > 0 && r.bottom > hoehe - 76) weg = true;
      }
    }
    if (weg !== hilfeWeg) {
      hilfeWeg = weg;
      root.classList.toggle('lc-hilfe-weg', weg);
    }
  }
  var hilfePlan = false;
  function hilfePlanen() {
    if (hilfePlan) return;
    hilfePlan = true;
    (win.requestAnimationFrame || win.setTimeout)(function () {
      hilfePlan = false;
      hilfeCheck();
    });
  }

  /* --- Quelle des Warenkorbs (Leiste oder Hauptknopf) ------------------- */
  var quelle = null;
  var quelleZeit = 0;
  function quelleMerken(q) {
    quelle = q;
    quelleZeit = Date.now();
  }
  function quelleLesen() {
    var q = quelle && Date.now() - quelleZeit < 15000 ? quelle : null;
    quelle = null;
    return q;
  }

  /* Nur der Hauptknopf der Seite zaehlt, nicht der Knopf einer Schnellansicht */
  function istHauptKnopf(t) {
    var k = t.closest('.main-product-form .product-form__submit');
    return !!k && k === hauptKnopf();
  }

  doc.addEventListener('click', function (ev) {
    try {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (leiste && t.closest('#lc-kaufleiste .lc-kaufleiste__knopf')) {
        quelleMerken('leiste');
        messen('lc_pdp_leiste_klick');
      } else if (amHandy() && istHauptKnopf(t)) {
        quelleMerken('kaufknopf');
        messen('lc_pdp_kaufknopf_klick');
      }
    } catch (e) { /* nie werfen */ }
  }, true);

  doc.addEventListener('product-ajax:added', function (ev) {
    try {
      var q = quelleLesen();
      if (!q) return;
      var p = ev && ev.detail && ev.detail.product;
      var wert = p && typeof p.final_line_price === 'number' ? p.final_line_price : 0;
      messen('lc_pdp_warenkorb', { quelle: q, wert_cent: wert });
    } catch (e) { /* nie werfen */ }
  });

  doc.addEventListener('product-ajax:error', function () {
    try {
      var q = quelleLesen();
      if (!q) return;
      messen('lc_pdp_warenkorb_fehler', { quelle: q });
    } catch (e) { /* nie werfen */ }
  });

  /* --- Kurztext: "Mehr lesen" springt zur ganzen Beschreibung ------------ */
  function kurztextStarten() {
    if (!kurztext) return;
    var link = kurztext.querySelector('[data-lc-mehr]');
    if (!link) return;
    var ziel = doc.querySelector('.product__block--description');
    if (!ziel) {
      /* keine Beschreibung in dieser Vorlage: Link ohne Ziel weg */
      link.hidden = true;
      link.style.display = 'none';
      return;
    }
    if (!ziel.id) ziel.id = 'lc-beschreibung';
    link.setAttribute('href', '#' + ziel.id);
    if (!ziel.hasAttribute('tabindex')) ziel.setAttribute('tabindex', '-1');
    link.addEventListener('click', function (ev) {
      try {
        ev.preventDefault();
        var weich = !(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
        ziel.scrollIntoView({ behavior: weich ? 'smooth' : 'auto', block: 'start' });
        try {
          ziel.focus({ preventScroll: true });
        } catch (e) { ziel.focus(); }
        messen('lc_pdp_mehr_lesen');
      } catch (e) { /* Standard-Sprung des Ankers bleibt */ }
    });
  }

  /* --- Start ------------------------------------------------------------- */
  try { kurztextStarten(); } catch (e) { /* nie werfen */ }
  try { leisteStarten(); } catch (e) { /* nie werfen */ }
  try { hilfeBeobachten(); } catch (e) { /* nie werfen */ }
  try {
    win.addEventListener('scroll', hilfePlanen, { passive: true });
    win.addEventListener('resize', hilfePlanen, { passive: true });
    if (mql) {
      var wechsel = function () {
        if (!amHandy()) {
          zeige(false);
        } else {
          try { leisteNeuPruefen(); } catch (e) { /* nie werfen */ }
        }
        hilfePlanen();
      };
      if (mql.addEventListener) mql.addEventListener('change', wechsel);
      else if (mql.addListener) mql.addListener(wechsel);
    }
    hilfeCheck();
  } catch (e) { /* nie werfen */ }
})();
